import { jsx } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import { useTheme, ThemeContext } from '../../utils/theme/theme-provider/index.esm.js';
import { EGDSBottomSheet } from '../bottom-sheet/index.esm.js';
import { EGDSPopoverSheet } from '../popover-sheet/index.esm.js';
import { EGDSSideSheet } from '../side-sheet/index.esm.js';
import { EGDSCenteredSheet } from '../centered-sheet/index.esm.js';
import { EGDSFullSheet } from '../full-sheet/index.esm.js';
import '../sheet-content/index.esm.js';
import '../sheet-close-button/index.esm.js';
import '../sheet-transition/index.esm.js';
import '../sheet-footer/index.esm.js';
import '../types/index.esm.js';
import styles from '../../styles/uitk-egds-sheet.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const Sheet = props => {
  const {
    autoFocus = true,
    children,
    className,
    type = 'bottom'
  } = props;
  const {
    className: themeClasses,
    ...themeDataAttributes
  } = useTheme();
  const themeContext = React.useContext(ThemeContext);
  const isColorThemeContainer = themeContext?.color?.isColorThemeContainer;
  const baseClassName = 'uitk-sheet';
  const sheetClassNames = getClassNameList(className, baseClassName, !isColorThemeContainer && themeClasses);
  let Tag;
  switch (type) {
    case 'bottom':
      Tag = EGDSBottomSheet;
      break;
    case 'centered':
      Tag = EGDSCenteredSheet;
      break;
    case 'full':
      Tag = EGDSFullSheet;
      break;
    case 'popover':
      Tag = EGDSPopoverSheet;
      break;
    case 'side':
      Tag = EGDSSideSheet;
      break;
    default:
      Tag = EGDSBottomSheet;
  }
  return jsx(Tag, {
    ...props,
    className: sheetClassNames,
    autoFocus: autoFocus,
    ...(!isColorThemeContainer && themeDataAttributes),
    children: children
  });
};
const EGDSSheet = props => {
  const l10n = useLocalization();
  return jsx(Sheet, {
    l10n: l10n,
    ...props
  });
};
EGDSSheet.displayName = 'EGDSSheet';
export { EGDSSheet, Sheet };